import type { BusinessType, PosSystem } from '../../../shared/enums';
import type { Lead } from '../../../shared/types';
import { loadRoute, saveRoute } from './corridor';
import { queueSignalPatch } from './signals';
import { kickSync } from './sync';

interface RouteLead {
  place_id: string;
  business_type: BusinessType;
  current_pos: PosSystem;
  signal_id?: string;
}

// Single-use navigation handoff. Never store provider names, addresses or coordinates.
let pending: RouteLead | undefined;
export const beginRouteLead = (value: RouteLead): void => {
  pending = {
    place_id: value.place_id, business_type: value.business_type, current_pos: value.current_pos,
    ...(value.signal_id ? { signal_id: value.signal_id } : {}),
  };
};
export const takeRouteLead = (placeId: string | null): RouteLead | undefined => {
  const value = pending;
  pending = undefined;
  return value?.place_id === placeId ? value : undefined;
};

export const finishRouteLead = async (context: RouteLead, lead: Lead): Promise<void> => {
  if (context.signal_id) {
    await queueSignalPatch(context.signal_id, { status: 'added', lead_id: lead.id }, `Add · ${lead.business_name}`);
    kickSync();
  }
  // Read current state: the route view that opened the form has been disposed.
  const route = loadRoute();
  if (!route) return;
  await saveRoute({ ...route, stops: route.stops.map(stop => {
    if (stop.place_id !== context.place_id) return stop;
    const { signal_id: _added, ...rest } = stop;
    return { ...rest, lead_id: lead.id };
  }) });
};
